import { Loading } from "gui/loading/loading";
import { FolderTile } from "../FolderTile/FolderTile";
import { useListFolders } from "./useListFolders";
import { FolderTileGroup } from "../FolderTile/FolderTileGroup";
import { SessionWithUser } from "lib/users/types";
import useFreetextFilterState from "gui/browse-shared/useFreetextFilterState";

export function ListFolders({ session }: { session: SessionWithUser }) {
  const { freetextFilterDebounced } = useFreetextFilterState();
  const results = useListFolders(session, { freetextFilterDebounced });

  if (results.loading) {
    return <Loading />;
  }

  return (
    <FolderTileGroup>
      <FolderTile
        icon="folder"
        color="gray"
        name="Creations"
        path="/creations"
        description="Home for your queries and dashboards."
      />
      {results.data &&
        results.data.get_folders.results.map((folder) => (
          <FolderTile
            key={folder.id}
            icon={folder.icon}
            color={folder.color}
            name={folder.name}
            path={folder.path}
            description={folder.description ?? undefined}
          />
        ))}

      <FolderTile
        icon="archive"
        color="red"
        name="Archived"
        path="/archived"
        description="All your archived queries and dashboards live here."
      />
    </FolderTileGroup>
  );
}
